import { render, staticRenderFns } from "./EditableTableBody.vue?vue&type=template&id=56dcf300&"
import script from "./EditableTableBody.vue?vue&type=script&lang=js&"
export * from "./EditableTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports